const dissectReportRouter = [
    {
        path:'',
        name:'dissectReport-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/dissectReport/index.vue'),
        redirect: { name: 'dissectReport-empty' },
        children:[
            {
                path:'',
                name:'dissectReport-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視解剖報告' }
            },
            // {
            //     path:'create',
            //     name:'dissectReport-create',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/dissectReport/create.vue')
            // },
            {
                path:'detail/:id',
                name:'dissectReport-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/dissectReport/detail.vue')
            },
            // {
            //     path:'edit/:id',
            //     name:'dissectReport-edit',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/dissectReport/edit.vue')
            // },
        ]
    },
    
  ]
  export default dissectReportRouter